import { Box } from "@mui/material";
import MultipleObjectChip from "../components/MultipleObjectChip";
import { CharFieldView } from "./charFieldView";
import { multiSelectValueFormatter } from "./multipleChoiceFieldView";
import {
  LabelValueForTags,
  LabelValueForText,
} from "components/ui/atoms/LabelValue";
import ObjectChip from "../components/ObjectChip";

const { getCommons } = require("./fieldConverterHelpers");

export const ManyRelatedFieldView = ({ value, field }) => {
  return (
    <LabelValueForTags
      label={field.label}
      sx={{ display: field.hidden ? "none" : "inherit" }}
      Tags={value.map((item, index) => {
        return (
          <ObjectChip
            key={index}
            objId={item}
            modelName={field.subModel}
            forceLoad={true}
          />
        );
      })}
      isMissing={value === undefined || value === null}
    />
  );
};

export const ManyRelatedFieldCell = ({ value, formattedValue, colDef }) => {
  if (!colDef._meta.field.subModel) return formattedValue;

  return (
    <Box onClick={(e) => e.stopPropagation()}>
      <MultipleObjectChip
        objIds={value}
        modelName={colDef._meta.field.subModel}
      />
    </Box>
  );
};

export const manyRelatedFieldConverter = ({ field }) => {
  return {
    ...getCommons({ field }),
    type: "singleSelect",
    valueOptions: field.choices || [],
    valueFormatter: multiSelectValueFormatter,
    renderCell: ManyRelatedFieldCell,
    sortable: false,
  };
};
